import { customerBaseApi } from "@/react/services/api";
import { handleMutationResponse } from "@/react/services/api/handleMutationResponse";
import { KEY } from "@/react/components/table/useTableMutations";
import { createNotifier } from "@/react/notifications";

const GATEWAY_DIDS = "GATEWAY_DIDS";
const trunkDidsUrlBuilder = (trunkId) => `trunk-config/${trunkId}/dids`;

export const trunkGatewayDidsApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getTrunkGatewayDids: build.query({
      query: ({ trunkId }) => ({
        url: trunkDidsUrlBuilder(trunkId),
        method: "GET",
      }),
      transformResponse: (response) =>
        // Keep freeform address and did properties at the same level
        response?.map((did) => ({
          ...did.didDto,
          address: {
            addressId: did.didDto?.addressId,
            freeForm: did.address,
          },
        })),
      providesTags: [GATEWAY_DIDS],
    }),
    bindTrunkGatewayDids: build.mutation({
      query: ({ trunkId, dids }) => ({
        url: `${trunkDidsUrlBuilder(trunkId)}/bulk/bind`,
        method: "POST",
        body: dids,
      }),
      invalidatesTags: [GATEWAY_DIDS],
    }),
    updateTrunkGatewayDids: build.mutation({
      query: ({ trunkId, dids }) => ({
        url: `${trunkDidsUrlBuilder(trunkId)}/bulk/update`,
        method: "PUT",
        body: dids,
      }),
      invalidatesTags: [GATEWAY_DIDS],
    }),
    deleteTrunkGatewayDids: build.mutation({
      query: ({ trunkId, didIds }) => ({
        url: `${trunkDidsUrlBuilder(trunkId)}/bulk/delete`,
        method: "DELETE",
        body: didIds,
      }),
      invalidatesTags: [GATEWAY_DIDS],
    }),
  }),
});

export const {
  useGetTrunkGatewayDidsQuery,
  useBindTrunkGatewayDidsMutation,
  useUpdateTrunkGatewayDidsMutation,
  useDeleteTrunkGatewayDidsMutation,
} = trunkGatewayDidsApi;

export const handleUpdateResponse = ({
  rowsToUpdate,
  setRowsToUpdate,
  setData,
  idKey,
}) =>
  handleMutationResponse({
    rows: rowsToUpdate,
    setRows: setRowsToUpdate,
    setData,
    responseMappingKey: idKey,
    idKey: KEY,
    notifyContent: createNotifier("update", "Gateway DID"),
  });

export const handleDeleteResponse = ({
  rowsToDelete,
  setRowsToDelete,
  setData,
  idKey,
}) =>
  handleMutationResponse({
    rows: rowsToDelete,
    setRows: setRowsToDelete,
    setData,
    responseMappingKey: idKey,
    idKey: KEY,
    notifyContent: createNotifier("delete", "Gateway DID"),
    isVoidResponse: true,
  });
